import React, { useState, useEffect } from "react";
import { View } from "./view";
import PageLoader from "../../../common/PageLoader";
import { CreateEditProfile } from "../Edit";
import { ICreateProfile } from "../../../../@types";
import { useUserStore } from "../../../../state";
import NewEditIcon from "../../../../assets/icons/NewEditIcon";
import { TickIcon } from "../../../../assets/icons/TickIcon";
import { useCompanyStore } from "../../../../state/useCompanyStore";
import { CloseIcon } from "../../../../assets/icons";
import { useNavigate } from "react-router-dom";

interface FormData {
  firstName: string;
  lastName: string;
  businessName: string;
  industry: string;
  email: string;
  phone: string;
  address: string;
  state: string;
  city: string;
  businessSize: string;
  code: string;
  brandColor: string;
  logoBase64: string;
  isVerified: boolean;
}

export const ViewProfile = ({ onClose }: { onClose: () => void }) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showEditProfile, setShowEditProfile] = useState<boolean>(false);
  const user = useUserStore((state) => state.user);
  const userStore = useCompanyStore();
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate("/settings/edit");
    onClose();
  };

  const [formData, setFormData] = useState<FormData>({
    firstName: "",
    lastName: "",
    businessName: "",
    email: "",
    phone: "",
    industry: "",
    address: "",
    state: "",
    city: "",
    businessSize: "",
    brandColor: "",
    code: "",
    logoBase64: "",
    isVerified: false,
  });

  const fetchUserData = async () => {
    try {
      const userData = userStore.company;
      if (userData) {
        setFormData({
          firstName: userData.firstName || "",
          lastName: userData.lastName || "",
          businessName: userData.businessName || "",
          email: userData.email || "",
          phone: userData.phone || "",
          industry: userData.industry || "",
          address: userData.address || "",
          state: userData.state || "",
          city: userData.city || "",
          businessSize: userData.businessSize || "",
          brandColor: userData.brandColor || "",
          code: userData.code || "",
          logoBase64: userData.logoBase64 || "",
          isVerified: userData.isVerified || false,
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [userStore.company]);

  const handleUpdatedProfileData = (updatedData: ICreateProfile) => {
    if (
      typeof updatedData.brandLogo === "string" ||
      updatedData.brandLogo === undefined ||
      updatedData.brandLogo === null
    ) {
      setFormData({
        firstName: updatedData.firstName,
        lastName: updatedData.lastName,
        businessName: updatedData.businessName,
        email: updatedData.email,
        phone: updatedData.phone,
        industry: updatedData.industry,
        address: updatedData.address,
        state: updatedData.state,
        city: updatedData.city,
        code: updatedData.code,
        businessSize: updatedData.businessSize,
        brandColor: updatedData.brandColor as string,
        logoBase64: updatedData.logoBase64 as string,
        isVerified: updatedData.isVerified,
      });
    } else {
    }
  };

  return (
    <>
         {isLoading ? (
        <PageLoader />
      ) : (
        <>
          {/* Overlay to close the sidebar */}
          <div
            className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop-blur-sm "
            onClick={onClose}
          ></div>

          {/* Sidebar Modal */}
          <div className="fixed top-0 right-0 h-full w-[90%] md:w-[35%] bg-white shadow-lg z-50 transform transition-transform duration-300  ease-in-out overflow-y-auto animate-slide-in-right">
            <div className="relative p-6">
              {/* Close Button */}
              <div className="flex items-center justify-between">

                {/* Title */}
              <h1 className="text-[20px] font-medium leading-6">My account</h1>
              
              <button
                className=" flex justify-center items-center mx-3  text-black hover:text-gray-900"
                onClick={onClose}
              >
                <CloseIcon className="cursor-pointer" />
              </button>

              
              </div>
             

              {/* User Info */}
              <div className=" my-4 py-4 rounded-[8px] flex justify-between mt-[50px] items-center">
                <div className="flex items-center gap-2 md:gap-[17px]">
                  <div className="bg-[#E0EEFE] w-6 h-6 md:w-[50px] md:h-[50px] rounded-full text-[8.4px] md:text-[35px] text-[#ffff] flex justify-center items-center">
                    {formData.firstName[0]}
                  </div>

                  <div className=" text-[15px] md:text-[18px]">
                    <div className="flex">
                      <h4 className="font-bold leading-[18px] pr-3">
                        {formData.businessName}
                      </h4>
                      {user.isVerified && (
                        <div className="flex border border-[#20A852] bg-[#F1F8F5] mt-[-0.4em] rounded-md">
                          <span className="mt-[0.3em] pl-1">
                            <TickIcon />
                          </span>
                          <span className=" text-[#20A852] lg:text-[14px] text-[10px] md:text-[12px] py-1 px-2 ">
                            RC Verified
                          </span>
                        </div>
                      )}
                    </div>
                    <p className="leading-[18px] text-gray-700 mt-2">{formData.email}</p>
                  </div>
                </div>

                {/* Edit Button */}
                <div
                  onClick={handleEdit}
                  className="flex items-center gap-1 text-[#044E97] bg-blue-100 px-3 py-1 rounded cursor-pointer"
                >
                  <p className="text-[16px] font-semibold leading-[22px]">
                    Edit
                  </p>
                  {/* <NewEditIcon /> */}
                </div>
              </div>

              {/* Profile Data */}
              <View formData={formData} />
            </div>
          </div>
        </>
      )}

      <CreateEditProfile
        show={showEditProfile}
        onClose={() => setShowEditProfile(false)}
        onCreateEditProfile={handleUpdatedProfileData}
      />
    </>
  );
};
